<template>
  <div class="container">
    <el-card shadow="never" class="cardTitle card">
      My Task - Last 30 Days
    </el-card>
    <el-row :gutter="20">
      <el-col :span="6" v-for="key in taskKeys" :key="key">
        <el-card shadow="never" class="card small-card">
          <p>{{ transKey2name(key) }}</p>
          <p @click="handleHref(key)" style="cursor: pointer">
            {{ task[key] }}
          </p>
        </el-card>
      </el-col>
    </el-row>
    <div>
      <table-view
        ref="tableList"
        :searchModel="searchModel"
        :tableModel="tableModel"
        :tableData="tableData.slice(0, 5)"
        tableCardTitle="Alert Summary—My Quick View"
        :showPage="false"
        :right-btn-options="{ text: 'More', isHavePermission: true }"
        @changeTitleActionBtn="handleRecords"
      >
        <template v-slot:companyName="{ tableRow }">
          <span class="customerId" @click="goSnapShot(tableRow.row)">
            {{ tableRow.row.companyName }}
          </span>
        </template>
        <template v-slot:totalOverdue="{ tableRow }">
          {{ tableRow.row.totalOverdue | formatAmount }}
        </template>
        <template v-slot:customerType="{ tableRow }">
          {{ getCustomerType(tableRow.row.customerType) }}
        </template>
      </table-view>
    </div>
    <div style="margin-top: 25px">
      <table-view
        ref="stockTableList"
        :tableModel="stockTableModel"
        :tableData="stockTableData"
        tableCardTitle="Alert Summary—Stock Volatility"
        :showPage="true"
        :pages="stockPage"
        :right-btn-options="{ text: 'My List', isHavePermission: true }"
        @changeTitleActionBtn="handleStockWatchList"
        @pageChange="handleStockPageChange"
      >
        <template v-slot:customerName="{ tableRow }">
          <span class="customerId" @click="goSnapShot(tableRow.row)">
            {{ tableRow.row.companyName }}
          </span>
        </template>
        <template v-slot:latestPrice="{ tableRow }">
          {{ tableRow.row.latestPrice }}
        </template>
        <template v-slot:roc="{ tableRow }">
          <div class="roc-container">
            <span
              :class="{
                'roc-positive': parseFloat(tableRow.row.roc) > 0,
                'roc-negative': parseFloat(tableRow.row.roc) < 0,
                'roc-neutral': parseFloat(tableRow.row.roc) === 0,
              }"
              class="roc-value"
            >
              <i
                :class="{
                  'el-icon-top': parseFloat(tableRow.row.roc) > 0,
                  'el-icon-bottom': parseFloat(tableRow.row.roc) < 0,
                  'el-icon-minus': parseFloat(tableRow.row.roc) === 0,
                }"
              ></i>
              {{ formatROC(tableRow.row.roc) }}
            </span>
          </div>
        </template>
        <template v-slot:updateTime="{ tableRow }">
          {{ tableRow.row.updateTime }}
        </template>
        <template v-slot:aiAnalysis="{ tableRow }">
          <div class="ai-analysis-btn-container">
            <el-button
              @click="openAIAnalysis(tableRow.row)"
              type="primary"
              size="mini"
              class="ai-analysis-btn"
              icon="el-icon-data-analysis"
            >
              AI Analysis
            </el-button>
          </div>
        </template>
      </table-view>
    </div>
    <div style="margin-top: 25px">
      <table-view
        ref="newsTableList"
        :tableModel="newsTableModel"
        :tableData="newsTableData"
        tableCardTitle="Alert Summary—Public Sentiment"
        :showPage="true"
        :pages="newsPage"
        :right-btn-options="{ text: 'My List', isHavePermission: true }"
        @changeTitleActionBtn="handleNewsWatchList"
        @pageChange="handleNewsPageChange"
      >
        <template v-slot:customerName="{ tableRow }">
          <span class="customerId" @click="goSnapShot(tableRow.row)">
            {{ tableRow.row.companyName }}
          </span>
        </template>
        <template v-slot:averageScore="{ tableRow }">
          <div class="average-score-wrapper">
            <div
              style="
                position: relative;
                width: 120px;
                height: 32px;
                display: flex;
                align-items: center;
              "
            >
              <!-- 背景条 -->
              <div
                :style="{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  height: '100%',
                  width: Number(tableRow.row.averageScore) * 100 + '%',
                  background:
                    Number(tableRow.row.averageScore) < 0.5
                      ? 'linear-gradient(135deg, #ffcdd2 0%, #ef5350 100%)'
                      : 'linear-gradient(135deg, #c8e6c8 0%, #66bb6a 100%)',
                  borderRadius: '6px',
                  opacity: '0.8',
                }"
              ></div>
              <!-- 文字 -->
              <span
                :style="{
                  position: 'relative',
                  color: '#ffffff',
                  padding: '4px 8px',
                  fontWeight: '600',
                  fontSize: '13px',
                  zIndex: '1',
                  display: 'inline-block',
                }"
              >
                {{ Number(tableRow.row.averageScore).toFixed(2) }}
              </span>
            </div>
          </div>
        </template>
        <template v-slot:positiveScore="{ tableRow }">
          <div class="sentiment-metric positive">
            <i class="el-icon-thumb"></i>
            <span class="metric-value">{{ tableRow.row.positiveScore }}</span>
          </div>
        </template>
        <template v-slot:negativeScore="{ tableRow }">
          <div class="sentiment-metric negative">
            <i class="el-icon-thumb" style="transform: rotate(180deg)"></i>
            <span class="metric-value">{{ tableRow.row.negativeScore }}</span>
          </div>
        </template>
        <template v-slot:neutralScore="{ tableRow }">
          <div class="sentiment-metric neutral">
            <i class="el-icon-remove-outline"></i>
            <span class="metric-value">{{ tableRow.row.neutralScore }}</span>
          </div>
        </template>
        <template v-slot:updateTime="{ tableRow }">
          {{ tableRow.row.updateTime }}
        </template>
        <template v-slot:newsDetail="{ tableRow }">
          <div class="ai-analysis-btn-container">
            <el-button
              @click="openNewsDetail(tableRow.row)"
              type="primary"
              size="mini"
              class="ai-analysis-btn"
              icon="el-icon-news"
            >
              News Analysis
            </el-button>
          </div>
        </template>
      </table-view>
    </div>
    <div style="margin-top: 25px">
      <table-view
        ref="tableList"
        :tableModel="tableModel2"
        :tableData="tableData2.slice(0, 5)"
        tableCardTitle="Recent Items"
        :showPage="false"
      >
        <template v-slot:name="{ tableRow }">
          <span class="customerId" @click="goSnShot(tableRow.row)">
            {{ tableRow.row.name }}
          </span>
        </template>
        <template v-slot:customerType="{ tableRow }">
          {{ getCustomerType(tableRow.row.customerType) }}
        </template>
      </table-view>
    </div>

    <el-row :gutter="20" style="margin-top: 24px">
      <el-col :span="12">
        <el-card shadow="never">
          <p class="arTitle">Total AR</p>
          <el-form
            :inline="true"
            :model="arForm"
            class="demo-form-inline"
            label-position="top"
            style="margin-top: 20px"
          >
            <el-form-item label="Date:">
              <el-date-picker
                v-model="arForm.dateValue[1]"
                type="date"
                @change="handleDateChange"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="GEO:">
              <el-select
                clearable
                v-model="arForm.geoValue"
                @change="handleGeoChange"
              >
                <el-option
                  v-for="item in geoList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="Region:">
              <el-select
                clearable
                v-model="arForm.regionValue"
                @change="handleRegionChange"
              >
                <el-option
                  v-for="item in regionList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="BU:">
              <el-select
                clearable
                v-model="arForm.buValue"
                @change="handleBuChange"
              >
                <el-option
                  v-for="item in buList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-form>

          <div class="chartsDecisions">
            <div>
              <v-chart :options="pieOptions"></v-chart>
            </div>
            <div v-if="this.pieData">
              <p>Currency: USD</p>
              <p>Unit: Millions</p>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card shadow="never" style="min-height: 708px">
          <p class="arTitle">Total Credit Trend</p>
          <el-row>
            <el-col :span="12">
              <div class="item-wrapper">
                <span>GEO</span>
                <el-select
                  @change="handleTotalGeo"
                  v-model="totalGeo"
                  clearable
                  style="width: 220px"
                >
                  <el-option
                    v-for="item in totalGeoList"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="item-wrapper">
                <span>Region</span>
                <el-select
                  @change="_getTotalTrend"
                  v-model="totalRegion"
                  clearable
                  style="width: 220px"
                >
                  <el-option
                    v-for="item in totalRegionList"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
          <el-form
            :inline="true"
            :model="trendForm"
            class="demo-form-inline"
            label-position="top"
            style="margin-top: 20px"
          >
            <el-form-item label="Date Range:">
              <el-date-picker
                v-model="trendForm.dateValue"
                type="daterange"
                range-separator="~"
                start-placeholder="Start Date"
                end-placeholder="End Date"
                @change="handleTrendChange"
                value-format="yyyy-MM-dd"
              ></el-date-picker>
            </el-form-item>
          </el-form>
          <v-chart :options="lineOptions"></v-chart>
        </el-card>
      </el-col>
    </el-row>
    <!--弹窗 -->
    <el-dialog title="Records" :visible.sync="showRecords">
      <table-view
        ref="tableList"
        :searchModel="searchModel"
        :tableModel="tableModel"
        :tableData="tableData"
        :pages="page"
        :showPage="true"
        @pageChange="handlePageChange"
      >
        <template v-slot:companyName="{ tableRow }">
          <span class="customerId" @click="goSnapShot(tableRow.row)">
            {{ tableRow.row.companyName }}
          </span>
        </template>
        <template v-slot:totalOverdue="{ tableRow }">
          {{ tableRow.row.totalOverdue | formatAmount }}
        </template>
      </table-view>
    </el-dialog>
    <!-- News Watch List Dialog -->
    <el-dialog
      title="My Watch List - News"
      :visible.sync="showNewsWatchList"
      width="80%"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-header">
        <span>My Watch List - News</span>
        <el-button
          type="primary"
          size="mini"
          @click="showAddNewsDialog = true"
          style="margin-left: 10px"
        >
          Add
        </el-button>
      </div>
      <table-view
        ref="newsWatchListTable"
        :tableModel="newsWatchListModel"
        :tableData="newsWatchListData"
        :pages="newsWatchListPage"
        :showPage="true"
        @pageChange="handleNewsWatchListPageChange"
      >
        <template v-slot:customerName="{ tableRow }">
          <span class="customerId" @click="goSnapShot(tableRow.row)">
            {{ tableRow.row.customerName }}
          </span>
        </template>
        <template v-slot:action="{ tableRow }">
          <el-button
            @click="deleteFromWatchList(tableRow.row, 2)"
            type="danger"
            size="mini"
            icon="el-icon-delete"
          >
            Delete
          </el-button>
        </template>
      </table-view>
    </el-dialog>
    <!-- Add Stock Dialog -->
    <el-dialog
      title="Add Stock to Watch List"
      :visible.sync="showAddStockDialog"
      width="800px"
    >
      <el-form :model="addStockForm" label-width="150px" ref="addStockForm">
        <el-form-item label="Customer Name" prop="customerId">
          <el-select
            v-model="addStockForm.customerId"
            placeholder="Customer ID / Customer Name"
            clearable
            filterable
            remote
            :remote-method="handleAddFormRemoteSearch"
            :loading="addFormCustomerLoading"
            @change="handleCustomerSelect"
            style="width: 100%"
          >
            <el-option
              v-for="customer in searchCompanyList"
              :key="customer.id"
              :label="customer.displayName"
              :value="customer.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="Stock Code" prop="stockCode">
          <el-input
            v-model="addStockForm.stockCode"
            placeholder="Please input stock code"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddStockDialog = false">Cancel</el-button>
        <el-button type="primary" @click="addStockToWatchList">
          Confirm
        </el-button>
      </div>
      <div class="watchlist-hint" style="margin-top:12px;color:#666;font-size:12px;text-align:center">
        Supports US Nasdaq, Hong Kong Stocks and China A-shares.
      </div>
    </el-dialog>
    <!-- Add News Dialog -->
    <el-dialog
      title="Add News to Watch List"
      :visible.sync="showAddNewsDialog"
      width="800px"
    >
      <el-form :model="addNewsForm" label-width="150px" ref="addNewsForm">
        <el-form-item label="Customer Name" prop="customerId">
          <el-select
            v-model="addNewsForm.customerId"
            placeholder="Customer ID / Customer Name"
            clearable
            filterable
            remote
            :remote-method="handleAddFormRemoteSearch"
            :loading="addFormCustomerLoading"
            @change="handleCustomerSelect"
            style="width: 100%"
          >
            <el-option
              v-for="customer in searchCompanyList"
              :key="customer.id"
              :label="customer.displayName"
              :value="customer.id"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAddNewsDialog = false">Cancel</el-button>
        <el-button type="primary" @click="addNewsToWatchList">
          Confirm
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="My Watch List - Stock"
      :visible.sync="showStockWatchList"
      width="80%"
      :close-on-click-modal="false"
    >
      <div slot="title" class="dialog-header">
        <span>My Watch List - Stock</span>
        <el-button
          type="primary"
          size="mini"
          @click="showAddStockDialog = true"
          style="margin-left: 10px"
        >
          Add
        </el-button>
      </div>
      <table-view
        ref="stockWatchListTable"
        :tableModel="stockWatchListModel"
        :tableData="stockWatchListData"
        :pages="stockWatchListPage"
        :showPage="true"
        @pageChange="handleStockWatchListPageChange"
      >
        <template v-slot:customerName="{ tableRow }">
          <span class="customerId" @click="goSnapShot(tableRow.row)">
            {{ tableRow.row.customerName }}
          </span>
        </template>
        <template v-slot:action="{ tableRow }">
          <el-button
            @click="deleteFromWatchList(tableRow.row, '1')"
            type="danger"
            size="mini"
            icon="el-icon-delete"
          >
            Delete
          </el-button>
        </template>
      </table-view>
      <div class="watchlist-hint" style="margin-top:12px;color:#666;font-size:12px;text-align:center">
        Supports US Nasdaq, Hong Kong Stocks and China A-shares.
      </div>
    </el-dialog>
    <!-- AI Analysis Dialog -->
    <el-dialog
      :visible.sync="showAIAnalysis"
      width="70%"
      :show-close="false"
      custom-class="ai-analysis-dialog"
    >
      <div slot="title" class="dialog-header">
        <div class="header-content">
          <div class="header-icon">
            <i class="el-icon-data-analysis"></i>
          </div>
          <div class="header-text">
            <h2>AI Stock Analysis Report</h2>
            <p>Powered by Advanced AI Intelligence</p>
          </div>
        </div>
        <el-button
          @click="showAIAnalysis = false"
          type="text"
          class="close-btn"
          icon="el-icon-close"
        ></el-button>
      </div>

      <div class="ai-analysis-content">
        <!-- Analysis Summary Card -->
        <div class="analysis-summary-card">
          <div class="card-header">
            <div class="indicator-dot analysis-dot"></div>
            <h3>
              <i class="el-icon-cpu"></i>
              Al Stock Technical Analysis
            </h3>
          </div>
          <div class="card-content">
            <div class="analysis-text enhanced">
              <div class="text-content">
                {{
                  currentAnalysis.aiAnalysis ||
                  'AI analysis data is being processed...'
                }}
              </div>
            </div>
          </div>
        </div>

        <!-- Investment Opinion Card -->
        <div class="investment-opinion-card">
          <div class="card-header">
            <div class="indicator-dot opinion-dot"></div>
            <h3>
              <i class="el-icon-trend-charts"></i>
              Comprehensive Stock Analysis
            </h3>
          </div>
          <div class="card-content">
            <div class="analysis-text enhanced">
              <div class="text-content">
                {{
                  currentAnalysis.investmentOpinion ||
                  'Investment opinion analysis in progress...'
                }}
              </div>
            </div>
          </div>
        </div>

        <!-- Action Footer -->
        <div class="dialog-footer">
          <div class="footer-info">
            <i class="el-icon-warning"></i>
            <span>
              This analysis is generated by AI and should be used for reference
              only. Please consult financial advisors for investment decisions.
            </span>
          </div>
          <div class="footer-actions">
            <el-button @click="showAIAnalysis = false" class="cancel-btn">
              Close
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- News Detail Dialog -->
    <el-dialog
      :visible.sync="showNewsDetail"
      width="80%"
      :show-close="false"
      custom-class="news-detail-dialog"
    >
      <div slot="title" class="dialog-header">
        <div class="header-content">
          <div class="header-icon">
            <i class="el-icon-news"></i>
          </div>
          <div class="header-text">
            <h2>Public Sentiment Analysis</h2>
            <p>AI-Powered News & Market Sentiment Report</p>
          </div>
        </div>
        <el-button
          @click="showNewsDetail = false"
          type="text"
          class="close-btn"
          icon="el-icon-close"
        ></el-button>
      </div>

      <div class="news-detail-content">
        <!-- Risk Assessment Card -->
        <div class="assessment-card" v-if="currentNewsDetail.riskAssessment">
          <div class="card-header">
            <div class="indicator-dot risk-dot"></div>
            <h3>
              <i class="el-icon-warning-outline"></i>
              Risk Assessment
            </h3>
          </div>
          <div class="card-content">
            <div class="analysis-text enhanced">
              <div class="text-content">
                {{ currentNewsDetail.riskAssessment }}
              </div>
            </div>
          </div>
        </div>

        <!-- AI Conclusion Card -->
        <div class="conclusion-card" v-if="currentNewsDetail.aiConclusion">
          <div class="card-header">
            <div class="indicator-dot conclusion-dot"></div>
            <h3>
              <i class="el-icon-cpu"></i>
              AI Conclusion
            </h3>
          </div>
          <div class="card-content">
            <div class="analysis-text enhanced">
              <div class="text-content">
                {{ currentNewsDetail.aiConclusion }}
              </div>
            </div>
          </div>
        </div>

        <!-- News Articles Card -->
        <div class="news-articles-card">
          <div class="card-header">
            <div class="indicator-dot news-dot"></div>
            <h3>
              <i class="el-icon-document"></i>
              News Articles Analysis
            </h3>
          </div>
          <div class="card-content">
            <table-view
              ref="newsDetailTableList"
              :tableModel="newsDetailTableModel"
              :tableData="newsDetailTableData || []"
              :showPage="false"
            >
              <template v-slot:title="{ tableRow }">
                <a
                  :href="tableRow.row.source"
                  target="_blank"
                  class="news-title-link"
                >
                  {{ tableRow.row.title }}
                </a>
              </template>
              <template v-slot:sentiment="{ tableRow }">
                <span :style="{
                  display: 'inline-block',
                  padding: '4px 8px',
                  borderRadius: '6px',
                  color: '#222',
                  fontWeight: '600'
                }">
                  {{ tableRow.row.sentiment }}
                </span>
              </template>
              <template v-slot:score="{ tableRow }">
                <div class="news-score-wrapper">
                  <div
                    style="
                      position: relative;
                      width: 80px;
                      height: 24px;
                      display: flex;
                      align-items: center;
                      background: #f0f0f0;
                      border-radius: 4px;
                    "
                  >
                    <!-- 背景条 -->
                    <div
                      :style="{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        height: '100%',
                        width: Math.abs(Number(tableRow.row.score)) * 100 + '%',
                        background:
                          tableRow.row.sentiment === 'positive'
                            ? 'linear-gradient(135deg, #c8e6c8 0%, #66bb6a 100%)'
                            : tableRow.row.sentiment === 'neutral'
                            ? 'linear-gradient(135deg, #fff9c4 0%, #fff176 100%)'
                            : tableRow.row.sentiment === 'negative'
                            ? 'linear-gradient(135deg, #ffcdd2 0%, #ef5350 100%)'
                            : (Number(tableRow.row.score) < 0
                              ? 'linear-gradient(135deg, #ffcdd2 0%, #ef5350 100%)'
                              : 'linear-gradient(135deg, #c8e6c8 0%, #66bb6a 100%)'),
                        borderRadius: '4px',
                        opacity: '0.9',
                      }"
                    ></div>
                    <!-- 文字 -->
                    <span
                      :style="{
                        position: 'relative',
                        color: '#333333',
                        padding: '2px 6px',
                        fontWeight: '600',
                        fontSize: '12px',
                        zIndex: '2',
                        display: 'inline-block',
                        textShadow: '0 0 3px rgba(255,255,255,0.8)',
                        width: '100%',
                        textAlign: 'center',
                      }"
                    >
                      {{ Number(tableRow.row.score).toFixed(2) }}
                    </span>
                  </div>
                </div>
              </template>
            </table-view>
          </div>
        </div>

        <!-- Action Footer -->
        <div class="dialog-footer">
          <div class="footer-info">
            <i class="el-icon-info"></i>
            <span>
              Sentiment analysis based on recent news articles and market data.
              Results are for reference purposes only.
            </span>
          </div>
          <div class="footer-actions">
            <el-button @click="showNewsDetail = false" class="cancel-btn">
              Close
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getWatchList,
  getTask,
  getTotalAr,
  getTotalTrend,
  getCusInfo,
  getRecently,
  getAddlog,
  getTotalSearchList,
  getStockList,
  getNewsList,
  getNewDetailList,
  getWatchStockNewsListData,
  deleteWatchStockNewsItem,
  addWatchStockNews,
} from './api'
import { getSelectList } from '@/api'
import dayjs from 'dayjs'
const selectList = ['BU', 'Region', 'Geo']

export default {
  name: 'dashboard',
  data() {
    const tableModel2 = [
      { slotName: 'name', label: 'Customer Name' },
      { prop: 'code', label: 'Customer#' },
      { slotName: 'customerType', label: 'Customer Type' },
    ]
    const tableModel = [
      { slotName: 'companyName', label: 'Customer Name' },
      { prop: 'companyCode', label: 'Customer#' },
      { slotName: 'totalOverdue', label: 'Overdue Amount' },
      { slotName: 'customerType', label: 'Customer Type' },
    ]
    const stockTableModel = [
      { slotName: 'customerName', label: 'Customer Name', align: 'center' },
      { prop: 'companyCode', label: 'Customer #', align: 'center' },
      { prop: 'stockCode', label: 'Stock Code', align: 'center' },
      { prop: 'market', label: 'Market', align: 'center' },
      { slotName: 'latestPrice', label: 'Latest Price', align: 'center' },
      { slotName: 'roc', label: 'ROC', align: 'center' },
      { slotName: 'updateTime', label: 'Update Time', align: 'center' },
      { slotName: 'aiAnalysis', label: 'AI Analysis', align: 'center' },
    ]
    const newsTableModel = [
      { slotName: 'customerName', label: 'Customer Name', align: 'center' },
      { prop: 'companyCode', label: 'Customer #', align: 'center' },
      { slotName: 'positiveScore', label: 'Positive %', align: 'center' },
      { slotName: 'negativeScore', label: 'Negative %', align: 'center' },
      { slotName: 'neutralScore', label: 'Neutral %', align: 'center' },
      { slotName: 'updateTime', label: 'Update Time', align: 'center' },
      { slotName: 'newsDetail', label: 'Al Analysis', align: 'center' },
    ]
    const newsDetailTableModel = [
      { slotName: 'title', label: 'Title', align: 'center' },
      // { slotName: 'source', label: 'Source' },
      { slotName: 'sentiment', label: 'Sentiment', align: 'center' },
      { slotName: 'score', label: 'Score', align: 'center' },
      { prop: 'curDate', label: 'Analysis Date', align: 'center' },
    ]
    const stockWatchListModel = [
      { slotName: 'customerName', label: 'Customer Name', align: 'center' },
      { prop: 'companyCode', label: 'Customer ID', align: 'center' },
      { prop: 'stockCode', label: 'Stock Code', align: 'center' },
      { slotName: 'action', label: 'Action', align: 'center' },
    ]

    const newsWatchListModel = [
      { slotName: 'customerName', label: 'Customer Name', align: 'center' },
      { prop: 'companyCode', label: 'Customer ID', align: 'center' },
      { slotName: 'action', label: 'Action', align: 'center' },
    ]
    return {
      showAddStockDialog: false,
      showAddNewsDialog: false,
      showStockWatchList: false,
      stockWatchListData: [],
      stockWatchListModel,
      stockWatchListPage: {
        current: 1,
        size: 10,
        total: 0,
      },
      addStockForm: {
        companyName: '',
        customerId: '',
        stockCode: '',
      },
      addNewsForm: {
        companyName: '',
        customerId: '',
      },
      // 搜索公司相关数据
      searchCompanyList: [],
      companyInput: '',
      addFormCustomerLoading: false,
      // News Watch List 数据
      showNewsWatchList: false,
      newsWatchListData: [],
      newsWatchListModel,
      newsWatchListPage: {
        current: 1,
        size: 10,
        total: 0,
      },
      searchModel: [],
      tableData: [],
      tableData2: [],
      stockTableData: [],
      newsTableData: [],
      allStockData: [],
      allNewsData: [],
      newsDetailTableData: [],
      tableModel,
      tableModel2,
      stockTableModel,
      newsTableModel,
      newsDetailTableModel,
      page: {},
      stockPage: {
        current: 1,
        size: 5,
        total: 0,
      },
      newsPage: {
        current: 1,
        size: 5,
        total: 0,
      },
      task: {},
      taskKeys: [], // 摘出需要的keys
      regionList: [], // region select list
      buList: [], // bu select list
      geoList: [], // geo select list
      arForm: {
        dateValue: [],
        regionValue: '',
        geoValue: '',
        buValue: '',
      },
      trendForm: {
        dateValue: [],
      },
      pieOptions: {
        tooltip: {
          trigger: 'item',
          formatter: '{b}:${c} ({d}%)',
        },
        legend: {
          top: '0%',
          left: 'center',
        },
        series: [
          {
            // name: 'data from:',
            type: 'pie',
            radius: ['40%', '70%'],
            avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 10,
              borderColor: '#fff',
              borderWidth: 2,
            },
            label: {
              show: false,
              position: 'center',
            },
            emphasis: {
              label: {
                show: true,
                fontSize: '20',
                fontWeight: 'bold',
              },
            },
            labelLine: {
              show: false,
            },
            data: [],
          },
        ],
      },
      showRecords: false,
      showAIAnalysis: false,
      showNewsDetail: false,
      currentAnalysis: {
        aiAnalysis: '',
        investmentOpinion: '',
      },
      currentNewsDetail: {
        riskAssessment: '',
        aiConclusion: '',
      },
      lineOptions: {
        title: {
          // text: '折线图堆叠',
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: [],
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          // x轴的坐标点
          data: [],
        },
        yAxis: {
          type: 'value',
        },
        // 几条线
        series: [],
      },
      pieData: [],
      totalGeo: '',
      totalRegion: '',
      totalGeoList: '',
      totalRegionList: '',
    }
  },
  mounted() {
    this._setCurData() // 设置当前时间和去年时间
    this._getTask()
    this._getWatchList()
    this._getTotalAr()
    this._getTotalTrend()
    this._gethistory()
    this._getStockList()
    this._getNewsList()
  },
  created() {
    // 获取下拉列表
    this.getAllSelect()
    this.getAllList()
  },
  watch: {
    showStockWatchList: {
      handler(newVal, oldVal) {
        // 当股票关注列表弹窗关闭时（从 true 变为 false）
        if (oldVal && !newVal) {
          // 刷新页面
          this.refreshPage()
        }
      },
    },
    showNewsWatchList: {
      handler(newVal, oldVal) {
        // 当弹窗关闭时（从 true 变为 false）
        if (oldVal && !newVal) {
          // 刷新页面
          this.refreshPage()
        }
      },
    },
  },
  methods: {
    formatROC(roc) {
      // 将 ROC 值格式化为两位小数
      const numValue = parseFloat(roc)
      if (isNaN(numValue)) return roc
      return numValue.toFixed(2) + '%'
    },
    async refreshPage() {
      // 重新获取所有需要的数据
      await this._getNewsList()
      await this._getStockList()
    },
    getCustomerType(type) {
      switch (type) {
        case 1:
          return 'Trade'
        case 2:
          return 'Eaas'
        case 3:
          return 'Saas'
        case 4:
          return 'CSS'
        default:
          return ''
      }
    },
    // Stock Watch List 相关方法
    async handleStockWatchList() {
      this.showStockWatchList = true
      await this._getStockWatchListData()
    },
    // 搜索公司相关方法
    async handleAddFormRemoteSearch(query) {
      if (query !== '') {
        this.addFormCustomerLoading = true
        try {
          // 使用与financial-report.vue相同的API
          const data = await this.searchCompanies(query)
          this.searchCompanyList = data.map(item => ({
            ...item,
            displayName: `${item.name} - ${this.getCustomerType(
              item.customerType,
            )}`,
          }))
        } catch (error) {
          console.error('搜索客户失败:', error)
          this.searchCompanyList = []
        } finally {
          this.addFormCustomerLoading = false
        }
      } else {
        this.searchCompanyList = []
      }
    },

    handleCustomerSelect() {
      // 当选择客户时，自动填充公司名称
      const selectedCustomer =
        this.searchCompanyList.find(
          customer => customer.id === this.addStockForm.customerId,
        ) ||
        this.searchCompanyList.find(
          customer => customer.id === this.addNewsForm.customerId,
        )

      if (selectedCustomer) {
        if (this.addStockForm.customerId === selectedCustomer.id) {
          this.addStockForm.companyName = selectedCustomer.name
          // 如果客户信息中包含stock code，也一并填充
          if (selectedCustomer.stockCode) {
            this.addStockForm.stockCode = selectedCustomer.stockCode
          }
        }
        if (this.addNewsForm.customerId === selectedCustomer.id) {
          this.addNewsForm.companyName = selectedCustomer.name
        }
      }
    },
    async searchCompanies(query) {
      // 使用与financial-report.vue相同的API
      const { getCustomerByName } = await import('@/views/ai/api') // 假设API在该路径
      return await getCustomerByName(query)
    },
    // Add Stock 相关方法
    async addStockToWatchList() {
      if (!this.addStockForm.customerId) {
        this.$message.warning('Please select customer name')
        return
      }
      if (!this.addStockForm.stockCode) {
        this.$message.warning('Please input stock code')
        return
      }

      try {
        const params = {
          type: 1, // Stock type
          companyName: this.addStockForm.companyName,
          stockCode: this.addStockForm.stockCode,
          companyId: this.addStockForm.customerId,
        }

        const result = await this.addWatchItem(params)
        if (result) {
          this.$message.success('Stock added to watch list successfully')
          this.showAddStockDialog = false
          this.addStockForm = { companyName: '', customerId: '', stockCode: '' }
          // 刷新股票关注列表
          await this._getStockWatchListData()
        } else {
          this.$message.error('Failed to add stock to watch list')
        }
      } catch (err) {
        console.error('添加股票关注失败:', err)
        this.$message.error('Failed to add stock to watch list')
      }
    },

    // Add News 相关方法
    async addNewsToWatchList() {
      if (!this.addNewsForm.customerId) {
        this.$message.warning('Please select customer name')
        return
      }

      try {
        const params = {
          type: 2, // News type
          companyName: this.addNewsForm.companyName,
          companyId: this.addNewsForm.customerId,
        }

        const result = await this.addWatchItem(params)
        if (result) {
          this.$message.success('News added to watch list successfully')
          this.showAddNewsDialog = false
          this.addNewsForm = { companyName: '', customerId: '' }
          // 刷新新闻关注列表
          await this._getNewsWatchListData()
        } else {
          this.$message.error('Failed to add news to watch list')
        }
      } catch (err) {
        console.error('添加新闻关注失败:', err)
        this.$message.error('Failed to add news to watch list')
      }
    },

    // 通用添加关注项方法
    async addWatchItem(params) {
      // 这里需要导入 addWatchStockNews 接口
      return await addWatchStockNews(params)
    },
    async _getStockWatchListData(params = { current: 1, size: 10 }) {
      try {
        const requestParams = {
          ...params,
          type: 1,
        }
        const result = await getWatchStockNewsListData(requestParams)
        if (result.data && result.page) {
          // 转换数据格式以匹配表格定义
          this.stockWatchListData = result.data.map(item => ({
            id: item.id,
            customerName: item.companyName,
            stockCode: item.stockCode,
            companyCode: item.companyCode,
            companyId: item.companyId,
          }))
          this.stockWatchListPage = result.page || {
            current: params.current,
            size: params.size,
            total: this.stockWatchListData.length,
          }
        } else {
          this.stockWatchListData = []
          this.stockWatchListPage = {
            current: params.current,
            size: params.size,
            total: 0,
          }
        }
      } catch (err) {
        console.error('获取股票关注列表失败:', err)
        this.$message.error('获取股票关注列表失败')
        this.stockWatchListData = []
        this.stockWatchListPage = {
          current: params.current,
          size: params.size,
          total: 0,
        }
      }
    },

    handleStockWatchListPageChange(params) {
      const _params = {
        size: params.size || 10,
        current: params.current,
      }
      this._getStockWatchListData(_params)
    },

    // News Watch List 相关方法
    async handleNewsWatchList() {
      this.showNewsWatchList = true
      await this._getNewsWatchListData()
    },

    async _getNewsWatchListData(params = { current: 1, size: 10 }) {
      try {
        const requestParams = {
          ...params,
          type: 2,
        }
        const result = await getWatchStockNewsListData(requestParams)

        if (result.data && result.page) {
          // 转换数据格式以匹配表格定义
          this.newsWatchListData = result.data.map(item => ({
            id: item.id,
            customerName: item.companyName,
            companyId: item.companyId,
            companyCode: item.companyCode,
          }))
          this.newsWatchListPage = result.page || {
            current: params.current,
            size: params.size,
            total: this.newsWatchListData.length,
          }
        } else {
          this.newsWatchListData = []
          this.newsWatchListPage = {
            current: params.current,
            size: params.size,
            total: 0,
          }
        }
      } catch (err) {
        console.error('获取新闻关注列表失败:', err)
        this.$message.error('获取新闻关注列表失败')
        this.newsWatchListData = []
        this.newsWatchListPage = {
          current: params.current,
          size: params.size,
          total: 0,
        }
      }
    },

    handleNewsWatchListPageChange(params) {
      const _params = {
        size: params.size || 10,
        current: params.current,
      }
      this._getNewsWatchListData(_params)
    },

    // 删除功能
    async deleteFromWatchList(row, type) {
      try {
        let confirmMessage = ''
        if (type === '1') {
          confirmMessage = `delete "${row.customerName}" stock watch list？`
        } else {
          confirmMessage = `delete "${row.customerName}" news watch list？`
        }
        await this.$confirm(confirmMessage, 'Delete', {
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          type: 'warning',
        })

        const result = await deleteWatchStockNewsItem({
          id: row.id,
          type: type,
        })

        if (result) {
          this.$message.success('Delete Successfully')
          // 根据类型刷新对应列表
          if (type === '1') {
            await this._getStockWatchListData({
              current: this.stockWatchListPage.current,
              size: this.stockWatchListPage.size,
            })
          } else {
            await this._getNewsWatchListData({
              current: this.newsWatchListPage.current,
              size: this.newsWatchListPage.size,
            })
          }
        } else {
          this.$message.error('Delete Fail')
        }
      } catch (err) {
        if (err !== 'cancel') {
          console.error("Delete Fail':", err)
          this.$message.error("Delete Fail'")
        }
      }
    },
    async handleTotalGeo(pid) {
      if (pid !== '') {
        await this.getAllList({
          typeMark: 'Region',
          pid,
        })
      }
      this._getTotalTrend()
    },
    async getAllList(params = { typeMark: 'Geo' }) {
      const data = await getTotalSearchList(params)

      if (params.typeMark === 'Geo') {
        this.totalGeoList = data
      } else if (params.typeMark === 'Region') {
        this.totalRegionList = data
      }
    },
    getAllSelect() {
      const pro = selectList.map(item => this._getSelectList(item))
      Promise.all(pro).then(res => {
        this.buList = res[0]
        this.geoList = res[2]
      })
    },
    async _getSelectList(typeMark) {
      try {
        return await getSelectList(typeMark)
      } catch (err) {
        console.log(err)
      }
    },
    async goSnapShot(data) {
      try {
        console.info(data)
        const { base } = await getCusInfo(data.companyId)
        await this.$storage.setItem('customerInfo', {
          name: data.companyName,
          address: base.address,
          code: base.code,
          country: base.countryStr,
          city: base.city,
          state: base.state,
        })
        let routeUrl = this.$router.resolve({
          path: `/customer-management/${data.companyId}/info/snapshot`, // 对应路由
        })
        window.open(routeUrl.href, '_blank')
        const params = {
          companyId: data.companyId,
        }
        await getAddlog(params)
      } catch (err) {
        console.error(err)
      }
    },
    async goSnShot(data) {
      try {
        const { base } = await getCusInfo(data.id)
        await this.$storage.setItem('customerInfo', {
          name: data.name,
          address: base.address,
          code: base.code,
          country: base.countryStr,
          city: base.city,
          state: base.state,
        })
        let routeUrl = this.$router.resolve({
          path: `/customer-management/${data.id}/info/snapshot`, // 对应路由
        })
        window.open(routeUrl.href, '_blank')
        const params = {
          companyId: data.id,
        }
        await getAddlog(params)
      } catch (err) {
        console.error(err)
      }
    },
    _setCurData() {
      this.arForm.dateValue = [
        dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD'),
      ]
      this.trendForm.dateValue = [
        dayjs().subtract(1, 'year').format('YYYY-MM-DD'),
        dayjs().format('YYYY-MM-DD'),
      ]
    },
    async _getTask() {
      try {
        this.task = await getTask()
        this.taskKeys = Object.keys(this.task).filter(
          key => key !== 'taskBatchCount',
        )
      } catch (err) {
        console.error(err)
      }
    },
    // 获取最近五家企业
    async _gethistory(params) {
      try {
        this.tableData2 = await getRecently(params)
      } catch (err) {
        console.error(err)
      }
    },
    async _getWatchList(params = { current: 1, size: 10 }) {
      try {
        const { data, page } = await getWatchList(params)
        this.tableData = data
        this.page = page
      } catch (err) {
        console.error(err)
      }
    },
    async _getTotalAr() {
      try {
        const params = {
          startTime: this.arForm.dateValue ? this.arForm.dateValue[1] : '',
          endTime: this.arForm.dateValue ? this.arForm.dateValue[1] : '',
          region: this.arForm.regionValue || '',
          bu: this.arForm.buValue || '',
          geo: this.arForm.geoValue || '',
        }
        const pieData = await getTotalAr(params)
        this.pieData = pieData
        if (pieData) {
          this.pieOptions = {
            ...this.pieOptions,
            series: [
              {
                ...this.pieOptions.series[0],
                data: Object.keys(pieData).map(key => ({
                  value: pieData[key],
                  name: this.transKey2name(key),
                  // name: key,
                })),
              },
            ],
          }
        } else {
          this.pieOptions = {
            ...this.pieOptions,
            series: [
              {
                ...this.pieOptions.series[0],
                data: [],
              },
            ],
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async _getTotalTrend() {
      try {
        const params = {
          startTime: this.trendForm.dateValue
            ? this.trendForm.dateValue[0]
            : '',
          endTime: this.trendForm.dateValue ? this.trendForm.dateValue[1] : '',
          geoId: this.totalGeo,
          regionId: this.totalRegion,
        }
        if (params.startTime && params.endTime) {
          const lineData = await getTotalTrend(params)
          let nape = []
          for (let i = 0; i < lineData.length; i++) {
            let res = JSON.parse(
              JSON.stringify(lineData[i]).replace(
                /totalCollateralAmount/g,
                'insuranceAmount',
              ),
            )
            nape.push(res)
          }
          this.lineOptions = {
            ...this.lineOptions,
            // legend 图表上面的标识指示
            legend: {
              data: nape[0]
                ? Object.keys(nape[0]).filter(key => key !== 'time')
                : [],
            },
            xAxis: {
              ...this.lineOptions.xAxis,
              data: nape.map(point => point.time),
            },
            series: nape[0]
              ? Object.keys(nape[0])
                  .filter(key => {
                    return key !== 'time'
                  })
                  .map(key => ({
                    name: key,
                    type: 'line',
                    // stack: '总量',
                    data: nape.map(item => item[key]),
                  }))
              : [],
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    handleRecords() {
      this.showRecords = true
    },
    openAIAnalysis(stockData) {
      this.currentAnalysis = {
        aiAnalysis: stockData.aiAnalysis || 'AAAAA',
        investmentOpinion: stockData.investmentOpinion || 'VVVVV',
      }
      this.showAIAnalysis = true
    },
    async _getStockList(params = { current: 1, size: 5 }) {
      try {
        // 如果是首次加载或者没有缓存数据，请求接口
        if (params.current === 1 || this.allStockData.length === 0) {
          const result = await getStockList(params)
          console.log(result)
          // 如果接口返回的是 { data: [], page: {} } 格式
          if (result.data && result.page) {
            this.stockTableData = result.data
            this.stockPage = result.page
            return
          } else {
            // 兼容原有格式 - 存储全部数据用于前端分页
            this.allStockData = result.data || result || []
          }
        }

        // 前端分页处理
        const startIndex = (params.current - 1) * params.size
        const endIndex = startIndex + params.size
        this.stockTableData = this.allStockData.slice(startIndex, endIndex)
        this.stockPage = {
          current: params.current,
          size: params.size,
          total: this.allStockData.length,
        }
      } catch (err) {
        console.error(err)
        this.stockTableData = []
        this.allStockData = []
      }
    },
    async _getNewsList(params = { current: 1, size: 5 }) {
      try {
        // 如果是首次加载或者没有缓存数据，请求接口
        if (params.current === 1 || this.allNewsData.length === 0) {
          const result = await getNewsList(params)
          // 如果接口返回的是 { data: [], page: {} } 格式
          if (result.data && result.page) {
            this.newsTableData = result.data
            this.newsPage = result.page
            return
          } else {
            // 兼容原有格式 - 存储全部数据用于前端分页
            this.allNewsData = result.data || result || []
          }
        }

        // 前端分页处理
        const startIndex = (params.current - 1) * params.size
        const endIndex = startIndex + params.size
        this.newsTableData = this.allNewsData.slice(startIndex, endIndex)
        this.newsPage = {
          current: params.current,
          size: params.size,
          total: this.allNewsData.length,
        }
      } catch (err) {
        console.error(err)
        this.newsTableData = []
        this.allNewsData = []
      }
    },
    async openNewsDetail(newsData) {
      try {
        // 获取新闻详情列表（表格数据）
        const newsDetailResult = await getNewDetailList({ id: newsData.id })
        this.newsDetailTableData =
          newsDetailResult.data || newsDetailResult || []

        // Risk Assessment 和 AI Conclusion 从当条数据（newsData）中获取
        this.currentNewsDetail = {
          riskAssessment: newsData.riskAssessment || '',
          aiConclusion: newsData.conclusion || '',
        }

        this.showNewsDetail = true
      } catch (err) {
        console.error('获取新闻详情失败:', err)
        // 即使获取失败也显示弹窗，使用当条数据
        this.newsDetailTableData = []
        this.currentNewsDetail = {
          riskAssessment: newsData.riskAssessment || '',
          aiConclusion: newsData.conclusion || '',
        }
        this.showNewsDetail = true
      }
    },
    getSourceName(source) {
      if (!source) return ''
      // 拆分 source，格式例如: "TipRanks (https://...)"
      const spaceIndex = source.indexOf(' (')
      if (spaceIndex > 0) {
        return source.substring(0, spaceIndex)
      }
      return source
    },
    getUrlFromSource(source) {
      if (!source) return '#'
      // 从 source 中提取 URL，格式例如: "TipRanks (https://...)"
      const urlMatch = source.match(/\((https?:\/\/[^)]+)\)/)
      return urlMatch ? urlMatch[1] : '#'
    },
    transKey2name(key) {
      switch (key) {
        case 'taskCount':
          return 'Pending Approval'
        case 'cancelledCount':
          return ' Cancelled '
        case 'successCount':
          return 'Approved'
        case 'failCount':
          return 'Declined'
        case 'overdueHundredEighty':
          return 'Past due 180+ '
        case 'overdueNinety':
          return 'Past due 91-180'
        case 'overdueSixty':
          return 'Past due 61-90'
        case 'overdueThirty':
          return 'Past due 31-60'
        case 'overdueOne':
          return 'Past due 1-30'
        case 'currentBucket':
          return 'Current Bucket'
      }
    },
    // date变化
    handleDateChange() {
      this._getTotalAr()
    },
    handleRegionChange() {
      this._getTotalAr()
    },
    async handleGeoChange(value) {
      this._getTotalAr()
      try {
        if (!value) {
          this.regionList = []
          this.arForm.regionValue = ''
          return
        }
        this.regionList = await this._getSelectList({
          typeMark: 'Region',
          pid: value,
        })
      } catch (err) {
        console.error(err)
      }
    },
    handleBuChange() {
      this._getTotalAr()
    },
    handleTrendChange() {
      this._getTotalTrend()
    },
    handlePageChange(params) {
      const _params = {
        size: 10,
        current: params.current,
      }
      this._getWatchList(_params)
    },
    handleStockPageChange(params) {
      const _params = {
        size: 5,
        current: params.current,
      }
      this._getStockList(_params)
    },
    handleNewsPageChange(params) {
      const _params = {
        size: 5,
        current: params.current,
      }
      this._getNewsList(_params)
    },
    handleHref(key) {
      if (key === 'taskCount') {
        // pending approval
        this.$router.push(
          '/credit-management/credit-audit-history/single-history?fromHome=pending',
        )
      }
      if (key === 'successCount') {
        // Approved
        this.$router.push(
          '/credit-management/credit-audit-history/single-history?fromHome=approved',
        )
      }
      if (key === 'failCount') {
        // Declined
        this.$router.push(
          '/credit-management/credit-audit-history/single-history?fromHome=fail',
        )
      }
      if (key === 'cancelledCount') {
        // cancelledCount
        this.$router.push(
          '/credit-management/credit-audit-history/single-history?fromHome=cancel',
        )
      }
    },
  },
}
</script>

<style scoped lang="less">
.container {
  //background-color: pink;
  .customerId {
    color: blue;
    cursor: pointer;
  }
  .card {
    margin-bottom: 24px;
  }
  .small-card {
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    p:nth-child(1) {
      font-size: 14px;
      color: #858ebd;
      letter-spacing: 0;
      text-align: center;
      line-height: 30px;
      font-weight: 700;
    }
    p:nth-child(2) {
      font-size: 26px;
      color: #222653;
      letter-spacing: 0;
      text-align: center;
      line-height: 30px;
      font-weight: 700;
    }
  }
  .cardTitle {
    font-size: 16px;
    color: #3a3f63;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 700;
  }
  .arTitle {
    font-size: 16px;
    color: #3a3f63;
    letter-spacing: 0;
    line-height: 24px;
    font-weight: 700;
  }
  .chartsDecisions {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .item-wrapper {
    display: flex;
    align-items: center;
    padding-top: 20px;
    span {
      margin-right: 10px;
    }
  }

  /* AI Analysis Dialog Enhancement */
  :deep(.ai-analysis-dialog) {
    .el-dialog__header {
      padding: 0;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border-radius: 8px 8px 0 0;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .dialog-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border-radius: 8px 8px 0 0;

    .header-content {
      display: flex;
      align-items: center;
      gap: 16px;

      .header-icon {
        width: 48px;
        height: 48px;
        background: rgba(255, 255, 255, 0.2);
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        i {
          font-size: 24px;
          color: white;
        }
      }

      .header-text {
        h2 {
          margin: 0;
          font-size: 24px;
          font-weight: 700;
          color: white;
        }

        p {
          margin: 4px 0 0 0;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.8);
          font-weight: 400;
        }
      }
    }

    .close-btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.2);
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }

      i {
        font-size: 16px;
        margin: 0;
      }
    }
  }

  .ai-analysis-content {
    padding: 32px;
    background: #f8f9ff;
    min-height: 500px;

    .analysis-summary-card,
    .investment-opinion-card {
      background: white;
      border-radius: 16px;
      margin-bottom: 24px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(102, 126, 234, 0.08);
      border: 1px solid rgba(102, 126, 234, 0.1);

      .card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 20px 24px;
        background: linear-gradient(135deg, #f8f9ff 0%, #e8eaff 100%);
        border-bottom: 1px solid rgba(102, 126, 234, 0.1);

        .indicator-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;

          &.analysis-dot {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }

          &.opinion-dot {
            background: linear-gradient(135deg, #20bf6b 0%, #26d0ce 100%);
          }
        }

        h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 8px;

          i {
            font-size: 20px;
            color: #667eea;
          }
        }
      }

      .card-content {
        padding: 24px;
      }
    }

    .analysis-text.enhanced {
      position: relative;

      .text-content {
        font-size: 15px;
        line-height: 1.7;
        color: #4a5568;
        background: #f7fafc;
        padding: 20px;
        border-radius: 12px;
        border-left: 4px solid #667eea;
        margin-bottom: 16px;
        min-height: 80px;
      }
    }

    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      background: white;
      border-radius: 12px;
      border: 1px solid #e2e8f0;

      .footer-info {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;

        i {
          color: #ed8936;
          font-size: 16px;
        }

        span {
          font-size: 12px;
          color: #718096;
          line-height: 1.4;
        }
      }

      .footer-actions {
        display: flex;
        gap: 12px;

        .cancel-btn {
          background: #f7fafc;
          border: 1px solid #e2e8f0;
          color: #4a5568;

          &:hover {
            background: #edf2f7;
            border-color: #cbd5e0;
          }
        }
      }
    }
  }

  /* News Detail Dialog Enhancement */
  :deep(.news-detail-dialog) {
    .el-dialog__header {
      padding: 0;
      background: linear-gradient(135deg, #20bf6b 0%, #26d0ce 100%);
      border-radius: 8px 8px 0 0;
    }

    .el-dialog__body {
      padding: 0;
    }
  }

  .news-detail-content {
    padding: 32px;
    background: #f8f9ff;
    min-height: 500px;

    .assessment-card,
    .conclusion-card,
    .news-articles-card {
      background: white;
      border-radius: 16px;
      margin-bottom: 24px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(32, 191, 107, 0.08);
      border: 1px solid rgba(32, 191, 107, 0.1);

      .card-header {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 20px 24px;
        background: linear-gradient(135deg, #f8f9ff 0%, #e8eaff 100%);
        border-bottom: 1px solid rgba(102, 126, 234, 0.1);

        .indicator-dot {
          width: 8px;
          height: 8px;
          border-radius: 50%;

          &.risk-dot {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }

          &.conclusion-dot {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }

          &.news-dot {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          }
        }

        h3 {
          margin: 0;
          font-size: 18px;
          font-weight: 600;
          color: #2c3e50;
          display: flex;
          align-items: center;
          gap: 8px;

          i {
            font-size: 20px;
            color: #667eea;
          }
        }
      }

      .card-content {
        padding: 24px;
      }
    }

    .news-title-link {
      color: #4834d4;
      text-decoration: none;
      font-weight: 500;
      transition: color 0.3s ease;

      &:hover {
        color: #686de0;
        text-decoration: underline;
      }
    }

    .news-score-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
    }

    .dialog-footer {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      background: white;
      border-radius: 12px;
      border: 1px solid #e2e8f0;

      .footer-info {
        display: flex;
        align-items: center;
        gap: 8px;
        flex: 1;

        i {
          color: #20bf6b;
          font-size: 16px;
        }

        span {
          font-size: 12px;
          color: #718096;
          line-height: 1.4;
        }
      }

      .footer-actions {
        display: flex;
        gap: 12px;

        .cancel-btn {
          background: #f7fafc;
          border: 1px solid #e2e8f0;
          color: #4a5568;

          &:hover {
            background: #edf2f7;
            border-color: #cbd5e0;
          }
        }
      }
    }
  }

  .ai-check-btn {
    color: #409eff;
    cursor: pointer;
    font-weight: 500;

    &:hover {
      color: #66b1ff;
    }
  }

  .news-detail-content {
    .news-table-section {
      margin-bottom: 24px;
    }

    .news-section {
      margin-bottom: 24px;

      h3 {
        font-size: 16px;
        font-weight: bold;
        color: #3a3f63;
        margin-bottom: 12px;
        border-bottom: 2px solid #f0f0f0;
        padding-bottom: 8px;
      }

      .news-text {
        font-size: 14px;
        line-height: 1.6;
        color: #666;
        background: #f8f9fa;
        padding: 16px;
        border-radius: 4px;
        border-left: 4px solid #28a745;
      }
    }

    .risk-assessment-section {
      margin-top: 32px;
    }
  }

  /* Stock Volatility Enhancement Styles */

  .roc-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 5;

    .roc-value {
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 14px;
      padding: 4px 8px;
      border-radius: 12px;
      min-width: 60px;
      justify-content: center;
      transition: all 0.3s ease;
      position: relative;

      i {
        margin-right: 4px;
        font-size: 12px;
      }

      &.roc-positive {
        background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%);
        color: #27ae60;
        border: 1px solid #a8d5a8;

        &:hover {
          background: linear-gradient(135deg, #d4edda 0%, #c3e6c3 100%);
          transform: scale(1.05);
          z-index: 999;
        }
      }

      &.roc-negative {
        background: linear-gradient(135deg, #ffeaea 0%, #ffcdd2 100%);
        color: #e74c3c;
        border: 1px solid #f5c6cb;

        &:hover {
          background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
          transform: scale(1.05);
          z-index: 999;
        }
      }

      &.roc-neutral {
        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
        color: #6c757d;
        border: 1px solid #dee2e6;

        &:hover {
          background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
          transform: scale(1.05);
          z-index: 999;
        }
      }
    }
  }

  .ai-analysis-btn-container {
    display: flex;
    justify-content: center;
    position: relative;
    z-index: 10;

    .ai-analysis-btn {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      border: none;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 600;
      transition: all 0.3s ease;
      box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
      position: relative;

      &:hover {
        transform: scale(1.05);
        background: linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%);
        z-index: 999;
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  /* Public Sentiment Enhancement Styles */
  .average-score-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .sentiment-metric {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6px 10px;
    border-radius: 16px;
    font-weight: 600;
    font-size: 13px;
    transition: all 0.3s ease;
    min-width: 65px;
    position: relative;

    i {
      margin-right: 6px;
      font-size: 14px;
    }

    &.positive {
      background: linear-gradient(135deg, #e8f5e8 0%, #c8e6c8 100%);
      color: #27ae60;
      border: 1px solid #a8d5a8;

      &:hover {
        background: linear-gradient(135deg, #d4edda 0%, #c3e6c3 100%);
        transform: scale(1.05);
        z-index: 999;
      }
    }

    &.negative {
      background: linear-gradient(135deg, #ffeaea 0%, #ffcdd2 100%);
      color: #e74c3c;
      border: 1px solid #f5c6cb;

      &:hover {
        background: linear-gradient(135deg, #f8d7da 0%, #f5c6cb 100%);
        transform: scale(1.05);
        z-index: 999;
      }
    }

    &.neutral {
      background: linear-gradient(135deg, #fff8e1 0%, #fff3cd 100%);
      color: #856404;
      border: 1px solid #ffeaa7;

      &:hover {
        background: linear-gradient(135deg, #fff3cd 0%, #ffeaa7 100%);
        transform: scale(1.05);
        z-index: 999;
      }
    }
  }

  /* Animation Effects */
  @keyframes pulse {
    0%,
    100% {
      opacity: 0.7;
    }
    50% {
      opacity: 1;
    }
  }

  @keyframes shimmer {
    0% {
      opacity: 0.6;
    }
    50% {
      opacity: 0.9;
    }
    100% {
      opacity: 0.6;
    }
  }
}
</style>
